import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { MrbButton } from "mrb/components/button";

const CertifierBulkActionsTemplate = observer(function CertifierBulkActionsTemplate({ contentListViewStore, t }) {
    const { selectedItems, bulkApprove, bulkReject, hasSelectedItems } = contentListViewStore;

    return (
        <div className="u-display--flex u-display--flex--ai--center u-gap--sml">
            {hasSelectedItems && (
                <span className="u-type--sml u-type--color--opaque">
                    {t("APPLICATION.CERTIFIER.DASHBOARD.BULK_ACTIONS.SELECTED_COUNT", { count: selectedItems.length })}
                </span>
            )}
            <MrbButton
                t={t}
                disabled={!hasSelectedItems}
                className="c-btn c-btn--sml c-btn--primary"
                onClick={bulkApprove}
                label={t("APPLICATION.CERTIFIER.DASHBOARD.BULK_ACTIONS.APPROVE_SELECTED")}
            />
            <MrbButton
                t={t}
                disabled={!hasSelectedItems}
                className="c-btn c-btn--sml c-btn--danger"
                onClick={bulkReject}
                label={t("APPLICATION.CERTIFIER.DASHBOARD.BULK_ACTIONS.REJECT_SELECTED")}
            />
        </div>
    );
});

CertifierBulkActionsTemplate.propTypes = {
    contentListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default CertifierBulkActionsTemplate;
